module.exports = __webpack_public_path__ + "static/media/wrong.cda675ab.mp3";